import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { color } from 'theme/tokens/color'

const styles: IStyles = {
    content: {
        position: 'absolute',
        top: 76,
        right: 0,
        bottom: 80,
        left: 0,
        padding: '24px 32px 32px',
        overflowY: 'auto',
    },
    mapContent: {
        position: 'absolute',
        top: 76,
        right: 0,
        bottom: 88,
        left: 0,
        overflow: 'hidden',
    },
    field: {
        marginBottom: 24,
    },
    advertisementStatus: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    advertisementStatusContent: {
        marginLeft: 12,
    },
    advertisementStatusLabel: {
        color: color.fontDarkUltraHigh,
        fontSize: 12,
        lineHeight: '16px',
    },
    advertisementStatusHint: {
        marginTop: 4,
        color: color.fontDarkMedium,
        fontSize: 10,
        lineHeight: '14px',
    },
    bulkAdvertisementStatus: {
        fontSize: 12,
        lineHeight: '16px',
    },
    bulkAdvertisementRadio: {
        marginBottom: 12,
    },
    advertisementRequirementsLink: {
        marginTop: 16,
        marginLeft: 44,
        padding: 0,
        background: 'none',
        border: 0,
        color: color.blue,
        fontSize: 12,
        lineHeight: '16px',
        cursor: 'pointer',
    },
    fieldLabel: {
        marginBottom: 8,
        fontSize: 12,
        lineHeight: '16px',
        color: color.fontDarkUltraHigh,
    },
    photoButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 64,
        height: 64,
        padding: 0,
        backgroundColor: color.bgWhiteSecondary,
        border: `1px solid ${color.borderDarkPrimary}`,
        borderRadius: 4,
        cursor: 'pointer',
        overflow: 'hidden',
    },
    photoPreview: {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    fileInput: {
        display: 'none',
    },
    photoAction: {
        marginTop: 8,
        padding: 0,
        background: 'none',
        border: 0,
        color: color.blue,
        fontSize: 12,
        lineHeight: '16px',
        cursor: 'pointer',
    },
    photoActionEmpty: {
        color: color.critical,
    },
    requirements: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: 24,
        padding: 16,
        border: `1px solid ${color.info200}`,
        borderRadius: 4,
        backgroundColor: color.info100,
        color: color.fontDarkHigh,
        fontSize: 12,
        lineHeight: '16px',
    },
    requirementsIcon: {
        flexShrink: 0,
        marginRight: 12,
        marginTop: 1,
    },
    requirementsTitle: {
        marginBottom: 4,
        color: color.fontDarkUltraHigh,
        fontWeight: 600,
    },
    requirementsSubtitle: {
        marginTop: 4,
        color: color.fontDarkUltraHigh,
        fontWeight: 600,
    },
    requirementsList: {
        margin: 0,
        paddingLeft: 18,
        listStyleType: 'disc',
        listStylePosition: 'outside',
    },
    linkButton: {
        marginTop: 8,
        padding: 0,
        background: 'none',
        border: 0,
        color: color.blue,
        fontSize: 12,
        lineHeight: '16px',
        cursor: 'pointer',
    },
    linkButtonWithError: {
        marginTop: 28,
    },
    linkArrow: {
        marginLeft: 6,
        fontSize: 16,
        lineHeight: '12px',
    },
    hint: {
        color: color.fontDarkMedium,
    },
}

addStyles(styles)

export default styles
